import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
1;
import { VueJsonp } from "vue-jsonp";
Vue.config.productionTip = false;
Vue.use(VueJsonp);
Vue.use(ElementUI);
import "./assets/icon/icon.css";

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
